import { JsonServiceClient } from '@servicestack/client';
import { Authenticate,getAvailableReq, registerMemberReq }  from './dtos';


class apiServices  {
    
   


    public client : JsonServiceClient;

   
    constructor() {

        
        let url = "";
     //   console.log(process.env.NODE_ENV);

       
        this.client =  new JsonServiceClient(this.apiUrl());
  

        this.client.bearerToken= localStorage.getItem("JsonServiceClient_bearerToken");
        this.client.refreshToken = localStorage.getItem("JsonServiceClient_refreshToken");

        // Intercept requests to ensure tokens are saved after refresh
        // The JsonServiceClient automatically refreshes tokens on 401, but we need to
        // ensure the refreshed tokens are persisted to localStorage
        const originalGet = this.client.get.bind(this.client);
        const originalPost = this.client.post.bind(this.client);
        const originalPut = this.client.put.bind(this.client);
        const originalDelete = this.client.delete.bind(this.client);
        const originalPatch = this.client.patch?.bind(this.client);

        const saveTokens = () => {
          if (this.client.bearerToken) {
            localStorage.setItem("JsonServiceClient_bearerToken", this.client.bearerToken);
          }
          if (this.client.refreshToken) {
            localStorage.setItem("JsonServiceClient_refreshToken", this.client.refreshToken);
          }
        };

        this.client.get = async (request: any, args?: any) => {
          const result = await originalGet(request, args);
          saveTokens();
          return result;
        };

        this.client.post = async (request: any, args?: any) => {
          const result = await originalPost(request, args);
          saveTokens();
          return result;
        };

        this.client.put = async (request: any, args?: any) => {
          const result = await originalPut(request, args);
          saveTokens();
          return result;
        };

        this.client.delete = async (request: any, args?: any) => {
          const result = await originalDelete(request, args);
          saveTokens();
          return result;
        };

        if (this.client.patch) {
          this.client.patch = async (request: any, args?: any) => {
            const result = await originalPatch(request, args);
            saveTokens();
            return result;
          };
        }

      }

      public getRoles = (): string[] => {
        const rolesJson = localStorage.getItem("JsonServiceClient_roles");
        if (rolesJson) {
          try {
            const roles = JSON.parse(rolesJson);
            console.log('[apiServices] getRoles() - Retrieved roles from localStorage:', roles);
            return roles;
          } catch (error) {
            console.error('[apiServices] getRoles() - Error parsing roles from localStorage:', error);
            return [];
          }
        }
        console.log('[apiServices] getRoles() - No roles found in localStorage');
        return [];
      }

      public hasHole = (roleName:string) :boolean =>
      {
        console.log(`[apiServices] hasHole() - Checking for role: "${roleName}"`);
        
        if(!this.client.bearerToken)
        {
            console.log('[apiServices] hasHole() - No bearer token, returning false');
            return false;
        }

        const roles = this.getRoles();
        console.log(`[apiServices] hasHole() - Current roles:`, roles);
        
        if(roles && roles.length > 0 && roles.includes(roleName))
        {
            console.log(`[apiServices] hasHole() - Role "${roleName}" found! Returning true`);
            return true;
        }

        console.log(`[apiServices] hasHole() - Role "${roleName}" not found. Returning false`);
        return false;
      }

      public apiUrl = () =>
      {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') 
        {
           
            return "https://localhost:8443";
           // return "https://iatseportaltest.azurewebsites.net";
            
        }
        return "";


      }

    parseJwt (token:string) {
        if(!token || token.split(".").length<2)
        {
            return null;
        }
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
    }
    
     

      public isloggedin = () => {
       
        if(
            this?.client!=null
            && this.client.bearerToken
            && this.client.refreshToken)           
           {
               return true;
           }
           else
           {
               return false;
           }
    }


    logout()
    {
        console.log('[apiServices] logout() - Clearing tokens and roles');
        localStorage.setItem("JsonServiceClient_bearerToken","");
        localStorage.setItem("JsonServiceClient_refreshToken","");
        localStorage.setItem("JsonServiceClient_roles","");
        
        const req = new Authenticate();
        req.provider = "logout";

        this.client.post(req);

        this.client.bearerToken=null;
        this.client.refreshToken =null;

    }


    register(email:string,password:string,invite_code:string, verification_code:string, captcha_value:string)
    {
        this.logout();
        

        const request = new registerMemberReq();
        request.email = email;
        request.pwd = password;
        request.invite_code = invite_code;
        request.verification_code = verification_code;
        request.captcha_value = captcha_value;

        return this.client.post(request).then(() => {
           
    
        });


    }
    login(email:string,password:string) {
    
    const request = new Authenticate();
    request.provider = "credentials";
    request.userName = email;
    request.password = password;
    request.rememberMe = true;
    this.client.refreshToken=null;
    this.client.bearerToken=null;

    return this.client.post(request).then((r) => {
        console.log('[apiServices] login() - Authentication response received:', {
          userId: r.userId,
          userName: r.userName,
          roles: r.roles,
          permissions: r.permissions
        });
        
        this.client.refreshToken = r.refreshToken;
        this.client.bearerToken = r.bearerToken;
        localStorage.setItem("JsonServiceClient_bearerToken", r.bearerToken);
        localStorage.setItem("JsonServiceClient_refreshToken", r.refreshToken);
        
        // Store roles from API response
        if (r.roles && Array.isArray(r.roles)) {
          console.log(`[apiServices] login() - Storing ${r.roles.length} roles in localStorage:`, r.roles);
          localStorage.setItem("JsonServiceClient_roles", JSON.stringify(r.roles));
        } else {
          console.warn('[apiServices] login() - No roles in response or roles is not an array. Storing empty array.');
          localStorage.setItem("JsonServiceClient_roles", JSON.stringify([]));
        }

    });
    
    }



    foo()
    {
      
        const request = new getAvailableReq();
        return this.client.get(request);

    }



}




export default apiServices;
